module.exports = __webpack_public_path__ + "static/media/backpage.ccdf65af.svg";